import React, { useState, useEffect } from 'react';
// import { logEvent } from "firebase/analytics";
// import { analytics } from './firebase';
import './App.css';

import { Art } from './slater/index.js';
// import { Resume } from './Resume';


function App() {
  // const [screen, setScreen] = useState('portfolio');
  // useEffect(() => {
  //   logEvent(analytics, 'land-page__Home');
  // })

  // const navClass = "app__nav-item app__nav-item-link app__nav-item--clickable"
  // const portfolioNavClasses = [navClass]
  // const resumeNavClasses = [navClass]
  // if (screen === 'portfolio') {
  //   portfolioNavClasses.push('app__nav-item--active')
  // } else if (screen === 'resume') {
  //   resumeNavClasses.push('app__nav-item--active')
  // }

  // return (
  //   <div className="App">
  //     <div className="app__nav">
  //       <h1 className="app__nav-item app__nav-item-title">Jason Buss</h1>
  //       <div className={portfolioNavClasses.join(' ')} onClick={() => setScreen('portfolio')}>portfolio</div>
  //       <div className={resumeNavClasses.join(' ')} onClick={() => setScreen('resume')}>resume</div>
  //     </div>
  //     <div className="app__body">
  //       { screen === 'portfolio' ? <Portfolio /> : <Resume /> }
  //     </div>
  //   </div>
  // );
  return (
    <Art />
  )
}

export default App;
